import { Box, Typography } from '@mui/material';
export default function FavoritesScreen() {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <Typography variant='h5' color='primary'>
                Favorites
            </Typography>
        </Box>
    );
}
